export enum DocumentSupportEnums {

    //Estados
    open = 1,
    close = 2,


    // Permisos
    exportExcel = 10
}